import { UntypedFormControl } from '@angular/forms';

export class Core {
  id: UntypedFormControl;
  name: UntypedFormControl;
  class: UntypedFormControl;
  group: UntypedFormControl;
  days: UntypedFormControl;
}
